import { ForwardPlayer } from "../../physics/players/ForwardPlayer";
import { DailyRewardReporter } from "./DailyRewardReporter";
import { DailyRewardMessage } from "./DailyRewardMessage";
import { DailyRewardItemsContainer } from "../../physics/DailyRewarditemsContainer";
import { GameConstants } from "../../GameConstants";
import { GameVars } from "../../GameVars";
import { DailyRewardFieldBoundaries } from "../../physics/DailyRewardFieldBoundaries";
import { AudioButtonsContainer } from "../AudioButtonsContainer";
import { AudioManager } from "../../AudioManager";
import { Player } from "../../physics/players/Player";
import { GameManager } from "../../GameManager";

    export class DailyRewardState extends Phaser.State {

        public static currentInstance: DailyRewardState;

        public initialized: boolean;

        private background: Phaser.Sprite;
        private forward: ForwardPlayer;
        private ballGroup: Phaser.Group;
        private canForwardShot: boolean;
        private ball: Phaser.Sprite;
        private creditsLabel: Phaser.Text;
        private reporter: DailyRewardReporter;
        private message: DailyRewardMessage;
        private rewardsContainer: DailyRewardItemsContainer;
        private ballShot: boolean;

        public init(): void { 
            
            DailyRewardState.currentInstance = this;

            this.ballShot = false;
        }
        
        public create(): void {

            this.game.physics.p2.reset();
            this.game.physics.p2.setBoundsToWorld(false, false, false , false);
            this.game.physics.p2.resume();

            this.initialized = true;
            this.canForwardShot = false;

            this.background = this.add.sprite(GameConstants.GAME_WIDTH / 2, 560, "lawn-background");
            this.background.scale.set(1.35, 1.35 * GameVars.scaleY * GameVars.fieldCorrectionScaleY);
            this.background.anchor.set(.5);
            this.background.inputEnabled = true;
            this.background.input.priorityID = 0;
            this.background.events.onInputDown.add(this.shoot, this);

            // debe haber sido creado un state para que los materiales funcionen
            GameVars.getInstance().createMaterials();

            const fieldBoundaries = new DailyRewardFieldBoundaries(this.game);
            this.add.existing(fieldBoundaries);

            this.rewardsContainer = new DailyRewardItemsContainer(this.game);
            this.add.existing(this.rewardsContainer);

            this.ballGroup = this.add.group();
            this.ballGroup.scale.y = GameVars.scaleY;

            this.message = new DailyRewardMessage(this.game);
            this.add.existing(this.message);

            // un boton de reset de escena mientras desarrollamos
            if (GameConstants.DEVELOPMENT) {
                const resetButton = this.add.button( 675, 90, "texture_atlas_5", this.onResetScene, this, "fx_button_on_on", "fx_button_on_off", "fx_button_on_on");
                resetButton.scale.y = GameVars.scaleY;
            }

            this.reporter = new DailyRewardReporter(this.game);
            this.add.existing(this.reporter);

            // el marco
            this.addFrame();
            this.addCredits();

            let audioButtons = new AudioButtonsContainer(this.game, new Phaser.Point(615, 10 * GameVars.scaleY), new Phaser.Point(675, 10 * GameVars.scaleY));
            audioButtons.scale.y = GameVars.scaleY;
            this.add.existing(audioButtons);

            this.game.time.events.add(1000, this.initialize, this);
        }
        
        public shutdown(): void {
            
            DailyRewardState.currentInstance = null;

            this.background.events.onInputDown.remove(this.shoot, this);
            
            super.shutdown();
        }

        public update(): void {

            super.update();

            if (this.ballShot) {
              
                if (this.ball.y > (GameConstants.GAME_HEIGHT + 50) / GameVars.scaleY) {
                    this.ballShot = false;
                    this.ball.destroy();
                    this.onBallHitBottom();
                }
            }
        }

        public initialize(): void {

            this.reporter.appear();
            this.message.appear();

            AudioManager.getInstance().playEffect("3_silvatos");
        }

        public showBall(): void {

            this.ball = this.add.sprite(GameConstants.GAME_WIDTH / 2, GameConstants.GAME_WIDTH / 2, "texture_atlas_2", "balon_extra");
            this.ball.anchor.set(.5);
            this.ball.scale.set(0);
            this.ballGroup.add(this.ball);

            this.game.add.tween( this.ball.scale)
                .to({x: 1, y: 1}, 600, Phaser.Easing.Elastic.Out, true);

            this.forward = new ForwardPlayer(this.game, GameConstants.GAME_WIDTH / 2, -100, true, null, Player.STILL);
            this.ballGroup.add(this.forward);

            this.ball.bringToTop();

            this.game.add.tween(this.forward.body)
                .to({y: 320 }, 750 , Phaser.Easing.Cubic.Out, true )
                .onComplete.add(function(): void {

                    // el delantero se queda parado frente a la pelota pudiendo chutar pasado un tiempo
                    this.game.time.events.add(500, function(): void {

                        this.canForwardShot = true;

                        this.forward.ball = this.ball;
                        this.ball.x = this.forward.shootBall_px;
                        this.ball.y = this.forward.shootBall_py;
                        this.forward.addChild(this.ball);
                        this.forward.prepareToShoot();
                    }, this);
                }, this);
        }


        public onCreditsWon(credits: number): void {

            this.reporter.onCreditsWon(credits);

            this.updateCredits();
        }

        public onNothingWon(): void {

            this.reporter.onNothingWon();
        }

        public onPowerUpWon(powerUpType: string): void {

            this.reporter.onPowerUpWon(powerUpType);
        }

        public onBallHitBottom(): void {

            this.ball.destroy();

            this.game.physics.p2.pause();

            this.rewardsContainer.openTrunks();

            const playButton = this.add.button( 670, 910 * GameVars.scaleY, "texture_atlas_5", this.onClickPlay, this);
            playButton.setFrames("play_button_on", "play_button_off", "play_button_on");
            playButton.anchor.setTo(.5);
            playButton.scale.y = GameVars.scaleY;
            playButton.visible = false;

            const pulseTween = this.game.add.tween(playButton.scale);
            pulseTween.to({x: 1.05, y: .95 * GameVars.scaleY}, 300, Phaser.Easing.Linear.None, false);
            pulseTween.to({x: .95, y: 1.05 * GameVars.scaleY}, 700, Phaser.Easing.Elastic.Out);
            pulseTween.loop();
            pulseTween.start();

            // mostrar el boton de play con un retraso
            this.game.time.events.add(1000, function(): void {
                playButton.visible = true;
            }, this);
        }

        public onClickPlay(): void {
 
            GameManager.onClickPlayDailyRewardState();
            
            AudioManager.getInstance().playEffect("play");
        }

        private shoot(): void {

            if (!this.canForwardShot) {
                return;
            }

            this.canForwardShot = false;
            this.ballShot = true;

            this.forward.hasReceived = false;
            this.forward.bringToTop();
            this.forward.shootBall();
            this.forward.ball.destroy();

            let px = this.forward.x;
            let py = this.forward.y;

            let angle = this.forward.getShootAngle();
            let angleInRadians = Math.PI / 180 * angle;

            let ball_px = px + 75 * Math.cos(angleInRadians);
            let ball_py = py + 75 * Math.sin(angleInRadians);

            this.ball = this.ballGroup.create(ball_px, ball_py, "texture_atlas_2", "balon_extra");
            this.game.physics.p2.enable(this.ball, GameConstants.SHOW_PHYSICS_BODIES);
            this.ball.body.data.type = Phaser.Physics.P2.Body.DYNAMIC;
            this.ball.body.setCircle(28);
            this.ball.body.mass = .025;

            let force = 1150;

            this.ball.body.velocity.x = force * Math.cos(angleInRadians);
            this.ball.body.velocity.y = force * Math.sin(angleInRadians);
        }


        private onResetScene(): void {

            this.game.state.start("DailyRewardState", true, false);
        }

        private addFrame(): void {

            let top = this.add.image(0, 0, "texture_atlas_6", "frame_rewards_top");
            this.add.image(0, top.height, "texture_atlas_6", "frame_rewards_left");
            
            let right = this.add.image(GameConstants.GAME_WIDTH, top.height, "texture_atlas_6", "frame_rewards_right");
            right.anchor.setTo(1, 0);
            this.add.image(0, top.height + right.height, "texture_atlas_6", "frame_rewards_bottom");
        }

        private addCredits(): void {

            let creditsCartridgeImage = new Phaser.Image(this.game, GameConstants.GAME_WIDTH / 2, 2 * GameVars.scaleY, "texture_atlas_5", "credits_cartridge" );
            creditsCartridgeImage.anchor.setTo(.5, 0);
            creditsCartridgeImage.scale.y = GameVars.scaleY;
            this.add.existing(creditsCartridgeImage);

            let creditsString: string = GameVars.formatNumber(GameVars.gameData.credits);

            this.creditsLabel = new Phaser.Text(this.game, GameConstants.GAME_WIDTH / 2, 35 * GameVars.scaleY, creditsString, { font: "36px Ubuntu", fontWeight: "700", fill: "#FFD51B", align: "center"});
            this.creditsLabel.anchor.set(.5);
            this.creditsLabel.blendMode = 3;
            this.creditsLabel.scale.y = GameVars.scaleY;
            this.add.existing(this.creditsLabel);
        }

        private updateCredits(): void {

            this.creditsLabel.text = GameVars.formatNumber(GameVars.gameData.credits);
            this.game.add.tween( this.creditsLabel.scale)
                .to ({x:  1.35, y: 1.15}, 500, Phaser.Easing.Elastic.Out, true, 0, 0, true);

            AudioManager.getInstance().playEffect("pick_coins");
        }
    }
